<script>
import Layout from "@/views/layouts/default";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

/**
 * Advanced table component
 */
export default {
  name: "DriverList",
  page: {
    title: "Driver",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Driver",
      items: [
        {
          text: "Manajemen Armada",
        },
        {
          text: "Driver",
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: {
        status: null,
        keyword: null
      },
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      fields: [
        { key: "ktp", label: "No KTP", sortable: false },
        { key: "name", label: "Name", sortable: true },
        { key: "email", label: "Email", sortable: true },
        { key: "phone", label: "Telepon", sortable: true },
        { key: "address", label: "Alamat", sortable: true },
        { key: "account_status", label: "Status", sortable: true },
        { key: "action", label: "", sortable: false }
      ],
      statusList: [
        { value: null, text: 'Semua Status' },
        { value: 'aktif', text: 'Aktif' },
        { value: 'tidak aktif', text: 'Tidak Aktif' },
      ]
    };
  },
  methods: {
    async fetchData(ctx) {
      const promise = this.$axios.get('/v1/logistic_company/driver', {
        params: {
          page: ctx.currentPage,
          per_page: ctx.perPage,
          key: ctx.filter.keyword,
          orderby: ctx.sortBy,
          sort: (ctx.sortDesc)? 'asc' : 'desc',
          account_status: ctx.filter.status
        }
      })

      // Must return a promise that resolves to an array of items
      return promise.then(response => {
        // Pluck the array of items off our axios response
        const items = response.data.data.rows
        this.totalRows = response.data.data.total_data
        // Must return an array of items or an empty array if an error occurred
        return items || []
      })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    downloadExcel() {
      this.$axios.get('/v1/logistic_company/driver/export', {
        params: {
          orderby: this.$refs.table.sortBy,
          sort: (this.$refs.table.sortDesc)? 'asc' : 'desc',
          key: this.filter.keyword,
          account_status: this.filter.status
        },
        responseType: 'blob'
      }).then((response) => {
        // create file link in browser's memory
        const href = URL.createObjectURL(response.data);

        // create "a" HTML element with href to file & click
        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', 'drivers.xlsx'); //or any other extension
        document.body.appendChild(link);
        link.click();

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
      })
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <p class="card-title-desc"></p>
            <div class="row mb-md-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    <b-button
                      to="/driver/create"
                      :disabled="$store.state.userdata.logistic_company.document_status !== 'disetujui' || $store.state.userdata.logistic_company.account_status !== 'aktif'"
                      variant="danger"
                      type="button"
                      class="ml-2 w-100"
                    >Tambah Driver</b-button>
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                  <div class="d-inline-flex align-items-center">
                    <b-form-select class="form-control ml-2" v-model="filter.status" :options="statusList"></b-form-select>
                    <b-form-input
                      v-model="filter.keyword"
                      type="search"
                      placeholder="Search..."
                      class="form-control w-100 ml-2"
                    ></b-form-input>
                    <b-button variant="danger" type="button" class="ml-2 w-100" @click="downloadExcel">Download Excel</b-button>
                  </div>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                ref="table"
                :items="fetchData"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
               <!-- KTP -->
                <template v-slot:cell(ktp)="data">                  
                  {{ data.item.ktp ? data.item.ktp.ktp_no : '-' }}
                </template>
                <!-- Aciton -->
                <template v-slot:cell(action)="data">                  
                  <b-button variant="danger" :to="`/driver/${data.item.id}`"  v-b-tooltip.hover title="View Detail" size="sm">View</b-button>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>